import VideoPlayer from "@/components/VideoPlayer";
import QRCodeSection from "@/components/QRCodeSection";
import { Button } from "@/components/ui/button";
import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { IoIosWarning } from "react-icons/io";

const testVideoIds = {
  gumlet: "6824bdec819f5aacc1b7cc9c",
  bunnystream: "700eafb0-d15d-42a3-8e06-a4f30a24741b",
  vimeo: "https://player.vimeo.com/progressive_redirect/playback/1085457682/rendition/1080p/file.mp4%20%281080p%29.mp4?loc=external&log_user=0&signature=3dded750ab90c7020f9261c2223b94d7b0cfba6280dfa6461e19c286b53742da",
};

const Index = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [isRetrying] = useState(() => searchParams.get("retry") === "true");

  const handlePlaybackSuccess = () => {
    // Video is playing successfully, no action needed
  };

  const handlePlaybackFailure = () => {
    navigate("/troubleshooting?error=true");
  };

  return (
    <div className="space-y-8">
      <section className="max-w-5xl mx-auto space-y-6">
        <div className="transform transition-all hover:scale-[1.01] duration-300">
          <VideoPlayer
            videoIds={testVideoIds}
            onPlaybackSuccess={handlePlaybackSuccess}
            onPlaybackFailure={handlePlaybackFailure}
            isRetrying={isRetrying}
          />
        </div>
      </section>

      {/* Action cards */}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 max-w-5xl mx-auto">
        <QRCodeSection />
        <div className="bg-white rounded-2xl border border-gray-200 shadow-sm hover:shadow-lg transition-all duration-200 p-6">
          <div className="flex flex-col gap-5 h-full">
            <div className="flex items-start gap-4">
              <div className="shrink-0 size-10 rounded-xl bg-gray-50 border border-gray-100 flex items-center justify-center">
                <IoIosWarning className="h-5 w-5 text-warning-medium" />
              </div>
              <div className="flex flex-col gap-1">
                <h3 className="text-base font-semibold text-gray-900">
                  Having trouble viewing the video?
                </h3>
                <p className="text-sm text-gray-500 leading-relaxed">
                  We can help you resolve browser issues you might be
                  experiencing.
                </p>
              </div>
            </div>
            <div className="mt-auto">
              <Button
                variant="outline"
                size="default"
                className="w-full flex items-center justify-center gap-2 rounded-lg border-gray-300 hover:bg-gray-50"
                onClick={() => navigate("/troubleshooting")}
              >
                <IoIosWarning className="h-4 w-4" />
                Troubleshoot Video
              </Button>
            </div>
          </div>
        </div>
      </div>
      {/* Vimeo Test button disabled
      <div className="max-w-5xl mx-auto">
        <Button
          variant="outline"
          size="sm"
          className="text-xs text-gray-400 border-gray-200"
          onClick={() => navigate("/vimeo-test")}
        >
          Vimeo Test →
        </Button>
      </div>
      */}
    </div>
  );
};

export default Index;
